import React, {useState, createContext, useContext, useEffect} from 'react'

const MainContext = createContext()

const MainContextProvider = ({ children }) => {

	const [currentSong, setCurrentSong] = useState({
		id: 2,
		name: 'Relaxing Ambiances',
		description: 'Relaxing Ambiances',
		cover: 'https://i.scdn.co/image/0079a2f002ad1e63b475646e226f534702cbc3c9'
	})
	const [methods, setMethods] = useState({})

	const data = {
		currentSong,
		setCurrentSong,
		methods,
		...methods,
		setMethods
	}

	// useEffect(() => {
	// 	console.log(methods)
	// }, [methods])

	return (
		<MainContext.Provider value={data}>
			{children}
		</MainContext.Provider>
	)
}

export {
	MainContextProvider,
	MainContext,
	useContext
}
